"use client";

import { useEffect, useState } from "react";
import { APP_STORE, APP_URL, PLAY_STORE } from "../content/common";

/*
 * Where "Explore Tulus" leads. app.tulus.my is the web version of the iOS and
 * Android app, so it is the default and what the prerendered HTML carries; on
 * an iPhone, iPad or Android phone the link goes to that platform's store
 * instead. When the web app should be the one destination for everyone, set
 * PHONES_GO_TO_STORES to false.
 */
const PHONES_GO_TO_STORES = true;

export function appUrlFor(userAgent: string, maxTouchPoints = 0): string {
  if (!PHONES_GO_TO_STORES) return APP_URL;
  // iPadOS reports itself as a Mac; touch points tell the two apart.
  if (/iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1)) return APP_STORE;
  if (/Android/.test(userAgent)) return PLAY_STORE;
  return APP_URL;
}

export function useAppUrl(): string {
  const [url, setUrl] = useState(APP_URL);
  useEffect(() => {
    setUrl(appUrlFor(navigator.userAgent, navigator.maxTouchPoints));
  }, []);
  return url;
}
